import { motion } from "framer-motion";
import { ArrowDown, Phone, ChevronRight, CalendarDays } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const HeroSection = () => {
  const navigate = useNavigate();

  const scrollToQuote = () => {
    document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" data-testid="hero-section" className="hero-bg relative min-h-screen flex items-center">
      <div className="absolute inset-0 z-0">
        <img
          src="https://customer-assets.emergentagent.com/job_auto-paint-brisbane/artifacts/4s7jjnjm_IMG_3046.jpeg"
          alt="Velocity Paint and Panel shop"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="hero-watermark" aria-hidden="true">VELOCITY</div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 w-full pt-32 pb-24">
        <div className="max-w-3xl">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex items-center gap-3 mb-8"
          >
            <div className="w-12 h-[1px] bg-[#3b82f6]" />
            <span data-testid="hero-tagline" className="text-sm tracking-[0.3em] uppercase text-zinc-400 font-body font-medium">
              101 Norman St, Woolloongabba, Brisbane
            </span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.4 }}
            data-testid="hero-heading"
            className="font-heading text-5xl sm:text-6xl lg:text-8xl uppercase leading-[0.9] tracking-tight text-white mb-8"
          >
            Precision
            <br />
            Automotive
            <br />
            <span className="text-[#3b82f6]">Refinishing</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            data-testid="hero-subtext"
            className="text-base md:text-lg text-zinc-400 font-body font-light max-w-xl mb-12 leading-relaxed"
          >
            JDM specialists delivering full resprays, custom paint jobs, and flawless repairs.
            No insurance work, just pure craftsmanship.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.8 }}
            className="flex flex-col sm:flex-row gap-4"
          >
            <button
              onClick={scrollToQuote}
              data-testid="hero-quote-btn"
              className="pulse-cta flex items-center justify-center gap-2 bg-white text-black font-heading text-lg tracking-[0.15em] uppercase px-10 py-4 hover:bg-zinc-200 transition-colors cursor-pointer border-none"
            >
              Get a Quote
              <ChevronRight size={18} />
            </button>
            <button
              onClick={() => navigate("/book")}
              data-testid="hero-book-btn"
              className="flex items-center justify-center gap-2 border border-[#3b82f6]/40 text-[#3b82f6] font-heading text-lg tracking-[0.15em] uppercase px-10 py-4 hover:bg-[#3b82f6]/10 transition-colors cursor-pointer bg-transparent"
            >
              <CalendarDays size={16} />
              Book Appointment
            </button>
            <a
              href="sms:0450645926"
              data-testid="hero-call-btn"
              className="flex items-center justify-center gap-2 border border-white/20 text-white font-heading text-lg tracking-[0.15em] uppercase px-10 py-4 hover:bg-white/5 transition-colors no-underline"
            >
              <Phone size={16} />
              0450 645 926
            </a>
          </motion.div>
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2"
      >
        <span className="text-xs tracking-[0.3em] uppercase text-zinc-600 font-body">Scroll</span>
        <motion.div animate={{ y: [0, 8, 0] }} transition={{ repeat: Infinity, duration: 1.5 }}>
          <ArrowDown size={16} className="text-zinc-600" />
        </motion.div>
      </motion.div>
    </section>
  );
};
